import template from './ticketProjectStatus.template.html';

export default {
  template,
  bindings: {
    ticket: '<',
    stage: '<',
    showLabels: '<',
    onStatusChange: '&'
  },
  controller: class controller {
    constructor(projectService, ticketService, TICKET) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.availableStatuses = TICKET.PROJECT_AVAILABLE_STATUSES;
      ctrl.currentStatus = ctrl.availableStatuses[0];

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.onStatusPicked = function (status) {
        ctrl.currentStatus = status;
        projectService.setTicketProjectHistory(ctrl.ticket, ctrl.stage, ctrl.currentStatus);
        ticketService
          .updateTicket({ id: ctrl.ticket.id, projectHistory: ctrl.ticket.projectHistory })
          .then(function (result) {
            if (result.status) {
              ctrl.onStatusChange();
            }
          });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.currentStatus = projectService.getTicketProjectStatus(ctrl.ticket, ctrl.stage.id);
      };
    }
  }
};
